/**
 * @file ふわっと出てくるやつ
 *
 */
'use strict';
import { throttle } from "lodash";

/**
 * @classname VisibleAnimationView
 * @classdesc ふわっと出てくるやつ
 */
export default class VisibleAnimationView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('VisibleAnimationView.constructor');
		this._$e = $e;
		this.init();
	};

	/**
	 * イベントをセット
	 *
	 * @memberof VisibleAnimationView
	 * @return {undefined}
	 */
	init() {
		console.log('VisibleAnimationView.init');
		document.addEventListener('scroll', throttle(() => {
			this._offset = this._$e.offset().top;
			this._scrolled = $(window).scrollTop();
			this._wh = $(window).height();

			if(this._scrolled > this._offset - this._wh + (this._wh / 6)) {
				this._$e.addClass('activate');
			}
		}, 200), { passive: true })	
	}
}
